var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "72",
        height: "72",
        viewBox: "0 0 72 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0)" } }, [
        _c("path", {
          attrs: {
            d:
              "M59.7617 28.4414L44.6692 38.9751C45.2138 40.9238 45.0607 42.996 44.2354 44.848L60.0085 59.4493V28.8791C60.0073 28.7919 59.9841 28.7064 59.9411 28.6301C59.898 28.5538 59.8364 28.489 59.7617 28.4414Z",
            fill: "#BD0F72"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M26.9254 38.7904L12.2289 28.4531C12.1592 28.5016 12.1022 28.5654 12.0624 28.6395C12.0227 28.7135 12.0013 28.7956 12 28.8791V59.3326L27.4348 45.1165C26.4736 43.1411 26.2921 40.8884 26.9254 38.7904Z",
            fill: "#BD0F72"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M35.8808 12L12.7764 28.212L12.9614 28.3404L27.0908 38.2809C27.7107 36.5146 28.8843 34.9843 30.4447 33.9073C32.0052 32.8304 33.8732 32.2615 35.7833 32.2816C39.9923 32.2816 43.2938 34.896 44.5057 38.4598L59.0052 28.3443L59.1923 28.2159L35.8808 12Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M43.9901 45.3281C43.237 46.7987 42.0859 48.0394 40.662 48.9154C39.238 49.7913 37.5957 50.2689 35.9135 50.2964C34.2313 50.3239 32.5736 49.9001 31.1206 49.0712C29.6675 48.2422 28.4746 47.0398 27.6717 45.5946L12.2607 59.7816C12.2607 59.7816 12.2607 59.803 12.2866 59.8361C12.3146 59.8807 12.3526 59.9184 12.3978 59.9464C12.443 59.9744 12.4941 59.9919 12.5473 59.9976H58.7005H59.4966C59.5373 59.9901 59.576 59.9745 59.6102 59.9517C59.6445 59.929 59.6735 59.8995 59.6956 59.8653L43.9901 45.3281Z",
            fill: "#8E0360"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M35.7652 49.8064C40.5769 49.8064 44.4776 45.9934 44.4776 41.2899C44.4776 36.5864 40.5769 32.7734 35.7652 32.7734C30.9534 32.7734 27.0527 36.5864 27.0527 41.2899C27.0527 45.9934 30.9534 49.8064 35.7652 49.8064Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M41.1481 38.5385C41.459 38.8425 41.4589 39.3351 41.148 39.639L34.8893 45.7549C34.5784 46.0587 34.0744 46.0587 33.7636 45.7549L30.2273 42.2981C29.9164 41.9942 29.9164 41.5015 30.2273 41.1977C30.5382 40.8938 31.0422 40.8938 31.353 41.1977L34.3266 44.1043L40.0224 38.5384C40.3333 38.2345 40.8373 38.2346 41.1481 38.5385Z",
            fill: "white"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M19.2657 32.7772L27.0866 38.2804C27.7262 36.5111 28.9159 34.9817 30.489 33.9062C32.0621 32.8308 33.94 32.2632 35.8595 32.2829C37.7791 32.3026 39.6443 32.9087 41.1939 34.0162C42.7436 35.1238 43.9001 36.6773 44.5015 38.4594L52.4956 32.8803V21.2611L45.212 14.3125H21.2518C20.724 14.3125 20.2178 14.5174 19.8446 14.8823C19.4714 15.2471 19.2617 15.7419 19.2617 16.2578L19.2657 32.7772Z",
            fill: "#E8E8E8"
          }
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M22.7578 25.0844C22.7578 24.8695 22.936 24.6953 23.1558 24.6953H48.531C48.7508 24.6953 48.929 24.8695 48.929 25.0844C48.929 25.2992 48.7508 25.4734 48.531 25.4734H23.1558C22.936 25.4734 22.7578 25.2992 22.7578 25.0844Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M42.293 31.0512C42.293 30.8363 42.4712 30.6621 42.691 30.6621H48.3885C48.6083 30.6621 48.7865 30.8363 48.7865 31.0512C48.7865 31.266 48.6083 31.4402 48.3885 31.4402H42.691C42.4712 31.4402 42.293 31.266 42.293 31.0512Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M22.7578 31.0512C22.7578 30.8363 22.936 30.6621 23.1558 30.6621H28.4135C28.6334 30.6621 28.8116 30.8363 28.8116 31.0512C28.8116 31.266 28.6334 31.4402 28.4135 31.4402H23.1558C22.936 31.4402 22.7578 31.266 22.7578 31.0512Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M22.8281 19.5551C22.8281 19.3402 23.0063 19.166 23.2261 19.166H38.4023C38.6221 19.166 38.8003 19.3402 38.8003 19.5551C38.8003 19.7699 38.6221 19.9441 38.4023 19.9441H23.2261C23.0063 19.9441 22.8281 19.7699 22.8281 19.5551Z",
            fill: "#23516B"
          }
        }),
        _c("path", {
          attrs: {
            d: "M45.2139 21.2513H52.4955L45.2119 14.3047L45.2139 21.2513Z",
            fill: "#999999"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("rect", {
            attrs: {
              width: "48",
              height: "48",
              fill: "white",
              transform: "translate(12 12)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }